import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { ListResponse, PaginationState, SalesAnalysisState } from '../types'

interface analysisParams {
    startDate: string
    endDate: string
    filter: string
    type?: string 
}

interface fetchSalesAnalyzesParams extends analysisParams, PaginationState {}

export const salesApi = createApi({
    reducerPath: 'salesApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['Sale'],
    endpoints: (build) => ({
        fetchSalesProfit: build.query<number, analysisParams>({
            query: (params) => ({
                url: `analysis`,
                method: 'GET',
                params,
            }),
            transformResponse: (response: any) => response.data,
        }),

        fetchSalesAnalyzes: build.query<
            ListResponse<SalesAnalysisState>,
            fetchSalesAnalyzesParams
        >({
            query: (params) => ({
                url: `/analysis/sales`,
                method: 'GET',
                params,
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.data.map(({ invoiceId }) => ({
                              type: 'Sale' as const,
                              invoiceId,
                          })),
                          { type: 'Sale', id: 'LIST' },
                      ]
                    : [{ type: 'Sale', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<SalesAnalysisState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),
    }),
})
